import { getSessionToken } from "@shopify/app-bridge-utils";
import { API, graphqlOperation } from "aws-amplify";
import { UPDATE_SHOP_PROP } from "./mutations";

export default function (shop, shopSetItem, app) {
    const db_keys = ["review_clicked", "welcome_video_watched", "first_cart_turn_on", "first_new_campaign_click", "first_new_campaign", "fb_pixel_trial_started"]
    const data = {}
    return {
        getItem (key) {
            const source = db_keys.includes(key) ? shop : data
            return shop[key] || null
        },
        async setItem (key, value) {
            if (db_keys.includes(key)) {
                const input = { [key]: value }
                const authToken = `Bearer ${await getSessionToken(app)}`
                API.graphql(
                    graphqlOperation(UPDATE_SHOP_PROP, {
                        id: shop.id,
                        input
                    }, authToken)
                ).then(() => {
                    shopSetItem(key, value);
                })
            } else {
                data[key] = value
            }
        }
    }
}